<template>
	<div v-if="page.page_type == 1" class="preview">
		<unit-handle
			v-if="bannerUnit"
			:type="type"
			top
			:name="bannerUnit.control_name"
			:uid="bannerUnit.page_control_id"
			:code="bannerUnit.control_code"
			:editable="bannerUnit.is_edit == 1"
			:auth="false"
		>
			<unit-comp-app :unit="bannerUnit"></unit-comp-app>
		</unit-handle>
		<div class="main" :style="previewStyle" :empty="otherUnit.length == 0">
			<div class="search flex-center">
				<i class="tf tf-search"></i>
				<p class="flex-grow">搜索产品/服务/关键词</p>
			</div>
			
			<template v-for="(unit, j) in otherUnit">
				<div v-if="insertIndex == j" class="insert-line"></div>
				<unit-handle
					:key="unit.page_control_id"
					:type="type"
					:index="j + 1"
					:name="unit.control_name"
					:uid="unit.page_control_id"
					:code="unit.control_code"
					:editable="unit.is_edit == 1"
					:delete-button="unit.is_can_delete == 1 && unit.load_type != 2"
					:switch-button="unit.is_can_enable == 1"
					:after="otherUnit[j+1]"
					:active="unit.state == 1"
				>
					<unit-comp-app :unit="unit"></unit-comp-app>
				</unit-handle>
			</template>
			<div v-if="insertIndex == otherUnit.length" class="insert-line"></div>
		</div>
	</div>
	
	<div v-else class="preview" :empty="otherUnit.length == 0">
		<template v-for="(unit, j) in otherUnit">
			<div v-if="insertIndex == j" class="insert-line"></div>
			<unit-handle
				:key="unit.page_control_id"
				:type="type"
				:index="j"
				:name="unit.control_name"
				:uid="unit.page_control_id"
				:code="unit.control_code"
				:editable="unit.is_edit == 1"
				:delete-button="unit.is_can_delete == 1 && unit.load_type != 2"
				:switch-button="unit.is_can_enable == 1"
				:after="otherUnit[j+1]"
				:active="unit.state == 1"
			>
				<unit-comp-app :unit="unit"></unit-comp-app>
			</unit-handle>
		</template>
		<div v-if="insertIndex == otherUnit.length" class="insert-line"></div>
	</div>
</template>

<script>
	import unitHandle from './unit_handle.vue'
	import unitCompPc from '@/components/decorate/unit_comp_pc.vue'
	import unitCompApp from '@/components/decorate/unit_comp_app.vue'
	import {mapState, updateState} from '@/submodule/components/createStore.js'
	import global from '@/submodule/assets/script/function';
	
	export default {
		components: {
			unitHandle,
			unitCompPc,
			unitCompApp
		},
		
		props: {
			type: String,
			page: Object,
			unitList: Array,
			background: Object
		},
		
		data() {
			return {
				insertIndex: -1
			}
		},
		
		computed: {
			...mapState('decorate', ['dragUnit', 'dragUnitPosition']),
			
			previewStyle() {
				return {
					'background-color': this.background.bgColor || '#fff',
					'background-image': `url('${this.background.bgImg}')`,
					'background-position': `0 ${this.type == 'pc' ? '0' : '-180px'}`
				}
			},
			
			bannerUnit() {
				return this.unitList[0];
			},
			
			otherUnit() {
				if (this.page.page_type == 1) {
					return this.unitList.map(item => item).splice(1);
				} else {
					return this.unitList;
				}
			}
		},
		
		watch: {
			dragUnitPosition(val) {
				!val && this.insertHandle();
				this.dragHandle();
			}
		},
		
		methods: {
			dragHandle: global.throttle(function() {
				var client = this.$el.getBoundingClientRect();
				var minX = client.left;
				var maxX = minX + client.width;
				var minY = client.top < 59 ? 59 : client.top;
				var maxY = minY + client.height;
				
				if (this.dragUnitPosition && this.dragUnitPosition.x >= minX && this.dragUnitPosition.x <= maxX && this.dragUnitPosition.y >= minY && this.dragUnitPosition.y <= maxY) {
					if (this.otherUnit.length == 0) {
						this.insertIndex = 0;
					} else {
						for (let i = 0; i < this.otherUnit.length; i++) {
							let unit = this.otherUnit[i];
							let $child = this.$children.find(item => item.uid == unit.page_control_id);
							let client = $child.$el.getBoundingClientRect();
						
							if (this.dragUnitPosition.y < client.top + client.height / 2 || unit.load_type == 2) {
								this.insertIndex = i;
								break;
							} else if (i == this.otherUnit.length - 1) {
								this.insertIndex = this.otherUnit.length;
							}
						};
					}
				} else {
					this.insertIndex = -1;
				}
			}),
			
			insertHandle() {
				if (this.insertIndex > -1) {
					this.request({
						url: '/decoration/control/add',
						data: {
							page_id: this.page.page_id,
							control_id: this.dragUnit.control_id,
							sort_id: this.insertIndex + (this.page.page_type == 1 ? 1 : 0)
						},
						success: () => {
							this.$bus.$emit('updateUnitList');
						}
					});
				}
				updateState('decorate', 'dragUnit', false);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.preview {
		&[empty] {
			&:after {
				content: '可在此拖入控件';
				display: block;
				padding: 0 5px;
				line-height: 20px;
				font-size: 12px;
				color: #000;
			}
		}
		
		.main {
			position: relative;
			border-radius: 14px 14px 0 0;
			padding-top: 28px;
			margin-top: -28px;
			overflow: hidden;
			background: #fff;
			background-repeat: no-repeat;
			box-shadow: 0 1px 5px 0 rgba(0,0,0,.1);
			
			&[empty] {
				&:after {
					content: '可在此拖入控件';
					display: block;
					padding: 0 5px;
					line-height: 20px;
					font-size: 12px;
					color: #000;
				}
			}
			
			&:before {
				content: '';
				position: absolute;
				left: 50%;
				top: 10px;
				width: 40px;
				height: 4px;
				border-radius: 2px;
				margin-left: -20px;
				background: rgba(0,0,0,.15);
			}
			
			.search {
				gap: 8px;
				height: 35px;
				border: 1px solid #ddd;
				border-radius: 4px;
				padding: 0 10px;
				margin: 0 12px 10px;
				font-size: 12px;
				color: #bbb;
				background: #fff;
				box-shadow: 0 1px 5px 0 rgba(0,0,0,.1);
			}
		}
	}
	
	.insert-line {
		z-index: 100;
		position: relative;
		outline: 1px solid #00BD8E;
		outline-width: 1px 0;
		
		&:before {
			content: '松开鼠标，控件将放置在这里';
			position: absolute;
			left: 0;
			top: -9px;
			width: 170px;
			line-height: 18px;
			font-size: 12px;
			text-align: center;
			color: #fff;
			background: #00BD8E;
		}
		
		&:after {
			content: '';
			position: absolute;
			top: -9px;
			left: 170px;
			border-width: 9px 0 9px 9px;
			border-style: solid;
			border-color: rgba(0,0,0,0) #00BD8E;
		}
	}
</style>
